import { render, staticRenderFns } from "./TermCondition.vue?vue&type=template&id=188b7541"
import script from "./TermCondition.vue?vue&type=script&lang=js"
export * from "./TermCondition.vue?vue&type=script&lang=js"
import style0 from "./TermCondition.vue?vue&type=style&index=0&id=188b7541&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports